module.exports = __webpack_public_path__ + "static/media/CA_2022_RT_PLUS_suspente_RT.03eb3fd0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/CA_2022_RT_PLUS_suspente_RT.jpg
// module id = 1151
// module chunks = 0